import { projects } from "../assets/project"

export const getProjects = ( length = 0 )=>{

    if(!length) return projects;

    const arr = []
    for(let i=0; i<length ; i++){
        arr.push(projects[i]);
    }
    return arr;
}